angular.module('dnecom')
    .controller('ProductProcessImagesController', ["$scope", "ProductUploadUtils", "MediaUtils", function ProductProcessImagesController($scope, ProductUploadUtils, MediaUtils) {
        $scope.product.reorderingImages = false;

        $scope.$on('product.beforeSave', function () {
            $scope.product.gallery = _.filter($scope.product.gallery, function (item) {
                if (item.isDeleted) {
                    MediaUtils.scheduleDelete(item.media.id);
                }

                return !item.isDeleted;
            });
        });

        $scope.$on('product.afterSave', function () {
            MediaUtils.processDelete();
        });

        $scope.uploadFiles = function (files) {
            if (files && files.length && typeof $scope.product.gallery != 'undefined') {
                if ($scope.product.gallery.length + files.length > 50) {
                    alert('You cannot upload more than 50 images.');
                    return;
                }

                for (var i = 0; i < files.length; i++) {
                    ProductUploadUtils.upload($scope.store, files[i], function (media) {
                        if ($scope.product.gallery.length < 50) {
                            $scope.product.gallery.push({
                                id: null,
                                isPrimary: false,
                                media: media
                            });
                        }
                    });
                }
            }
        };

        $scope.markImageAsPrimary = function (image, event) {
            event.preventDefault();

            $.each($scope.product.gallery, function (i, item) {
                item.isPrimary = false;
            });

            image.isPrimary = true;
        };

        $scope.isPrimary = function (image) {
            return image.isPrimary;
        };

        $scope.markImageForDelete = function (image, event) {
            event.preventDefault();

            $.each($scope.product.gallery, function (i, item) {
                if (item == image) {
                    item.isDeleted = true;
                }
            });

            image.isDeleted = true;
        };

        $scope.cancelImageDeletion = function (image, event) {
            event.preventDefault();

            delete image.isDeleted;
        };

        $scope.isMarkedForDelete = function (image) {
            return image.isDeleted;
        };

        $scope.startImagesReordering = function(event) {
            event.preventDefault();
            $scope.product.reorderingImages = true;

            $('#product-images').css('height', $('#product-images').height() + 'px').disableSelection().sortable().sortable('enable');
        };

        $scope.applyImagesReordering = function(event) {
            event.preventDefault();

            $('#product-images').css('height', '').sortable('disable');

            $('.product-image-thumb-column').each(function(index, element) {
                angular.forEach($scope.product.gallery, function(image) {
                    if (image.id == $(element).attr('image-id')) {
                        image.priority = index + 1;
                    }
                });
            });

            $scope.product.gallery.sort(function(a, b) {
                return a.priority - b.priority;
            });

            $scope.product.reorderingImages = false;
        };

        $scope.cancelImagesReordering = function(event) {
            event.preventDefault();

            $('#product-images').css('height', '').sortable('cancel').sortable('disable');

            $scope.product.reorderingImages = false;
        };

        var getMaxImagePriority = function() {
            var max = 0;

            angular.forEach($scope.product.gallery, function(image) {
                if (image.priority > max) {
                    max = image.priority;
                }
            });

            return max;
        };
    }]);
